export function isLowerCase(str) {
  return str.toLowerCase() === str;
}
/** Generates array of boolean values in which `true` indicates to an upper-case character */

export function generateCaseMap(word) {
  return word.split('').map(char => char !== char.toLowerCase());
}
/** Applies casing to syllabized word according to given `caseMap` */

export function applyCaseMap(syllables, caseMap) {
  let currentCaseIdx = 0;
  return syllables.map(syllable => {
    let casedSyllable = '';

    for (const char of syllable) {
      casedSyllable += caseMap[currentCaseIdx] ? char.toUpperCase() : char;
      currentCaseIdx++;
    }

    return casedSyllable;
  });
}